<template>
  <div class="logo-ani">
    <svg id="85d62cda-7294-46b5-a7f8-544dcda48f77" data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 453.54 102.87"><rect x="77.93" width="24.94" height="102.87"/><rect x="38.96" width="24.94" height="102.87"/><rect width="24.94" height="102.87"/><rect x="116.89" y="77.93" width="102.87" height="24.94"/><rect x="116.89" y="38.96" width="102.87" height="24.94"/><rect x="116.89" width="102.87" height="24.94"/><rect x="350.68" width="24.94" height="102.87"/><rect x="428.61" width="24.94" height="102.87"/><rect x="389.64" y="38.96" width="24.94" height="24.94"/><rect x="272.75" y="38.96" width="24.94" height="24.94"/><polygon points="311.71 77.93 233.78 77.93 233.78 102.86 311.71 102.86 336.65 102.86 336.65 77.93 336.65 38.96 311.71 38.96 311.71 77.93"/><polygon points="233.78 0 233.78 24.94 233.78 63.9 258.72 63.9 258.72 24.94 336.65 24.94 336.65 0 258.72 0 233.78 0"/></svg>
  </div>
</template>

<script>
export default {
  name: 'LogoAni',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";

.logo-ani {
  svg {
    fill: $black;
  }
}

</style>
